import { formatVariacaoPercentual } from "../../home.format";
import type { VariationBadgeViewModel } from "./types-variation-badge";

export function useVariationBadge(value: number): VariationBadgeViewModel {
  const isDown = value < 0;

  return {
    direction: isDown ? "queda" : value > 0 ? "alta" : "estável",
    isDown,
    texto: formatVariacaoPercentual(value),
  };
}
